<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="云与智慧办公" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <div class="list"><Divider orientation="left">云办公一体机</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/nas02.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">办公云盘一体机 LX5-OL101</Title>
                <Paragraph>
                  <Text>轻量高效，快速入门，售价 </Text>
                  <Numeral value="7130" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral> 起
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>四核8G内存，四盘位+1拓展盘位</li>
                      <li>
                          4TB高速机械硬盘X3，组raid5，性能强劲，安全可靠
                      </li>
                      <li>双千兆网络接入，助力文件快速传输</li>
                      <li>备份，共享，协同</li>
                      <li>精致，小巧，海量</li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/LX5-OL012-001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">办公一体机 LX5-OL012</Title>
                <Paragraph>
                  <Text>灵活耐用，开启混合办公模式丨售价</Text>
                  <Numeral value="9680" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>高达12盘位，海量扩展能力，伴随企业持续成长</li>
                      <li>
                          采用Intel高性能CPU，16GB-DDR4内存，全面释放强劲性能
                      </li>
                      <li>4TB高速机械硬盘X4，性能强劲，安全可靠</li>
                      <li>双2.5G网络接入，助力文件快速传输</li>
                      <li>备份，共享，协同</li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/server004.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">办公一体机 LX5-OS002</Title>
                <Paragraph>
                  <Text>海量高速，开启混合办公模式丨售价</Text>
                  <Numeral value="39680" format="0,0.00" style="font-weight: 600;">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>高达24盘位，海量扩展能力，伴随企业持续成长</li>
                      <li>
                          采用双路Intel-Xeon高性能可扩展金牌服务器专用CPU，128GB-DDR4内存，全面释放强劲性能
                      </li>
                      <li>16TB高速机械硬盘X6，性能强劲，安全可靠</li>
                      <li>双10G网络接入，助力文件快速传输</li>
                      <li>备份，共享，协同</li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
      </Row>
      <div class="list"><Divider orientation="left">云办公系统授权</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Icon type="ios-ribbon" size="88"/>
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">BlueOffice-轻量版</Title>
                <Paragraph>
                  <Text>简单可靠，轻松入门，售价 </Text>
                  <Numeral value="2000" format="0,0.00">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>/CPU
                </Paragraph>
                <Paragraph>
                  <Text>仅支持单节点，最大容量支持4TB</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Icon type="ios-ribbon" size="88"/>
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">BlueOffice-标准版</Title>
                <Paragraph>
                  <Text>分离部署，扩容无忧，售价 </Text>
                  <Numeral value="14000" format="0,0.00">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>/CPU
                </Paragraph>
                <Paragraph>
                  <Text>支持分离部署，可横向扩展，最大容量支持32TB</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Icon type="ios-ribbon" size="88"/>
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">BlueOffice-增强版</Title>
                <Paragraph>
                  <Text>数据可靠，系统无忧，售价 </Text>
                  <Numeral value="19000" format="0,0.00">
                      <template #prefix>
                          <strong>¥</strong>
                      </template>
                  </Numeral>/CPU
                </Paragraph>
                <Paragraph>
                  <Text>支持多节点+分离式部署，最大容量无限制</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
      </Row>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
export default {
  name: 'Blueiaas',
  components: {
    Header,
    HeaderSec
  },
  setup() {
  },
  data(){
    return {
      BreadcrumbList: [
        {
            title: '首页',
            to: '/'
        },
        {
            title: '云与智慧办公',
        }
      ],
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 100%;
}
.blueiaas-card{
  background-color:#f2f2f2;
  margin-top: 20px;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
  .blueiaas-card{
    background-color:#f2f2f2;
    margin-top: 20px;
  }
}
</style>
